import { useGetNotetakerEntitlementQuery } from './entitlement_api'

export const useNotetakerEntitled = () => {
  const { data, isLoading, isError } = useGetNotetakerEntitlementQuery()

  return {
    isEntitled: data?.entitled === true,
    isLoading,
    isError,
  }
}
